import type { VariantProps } from "class-variance-authority";
import { LoaderCircle, type LucideIcon } from "lucide-react";
import type { ComponentProps } from "react";

import { cn } from "@/lib/utils";

import { buttonVariants } from "./buttonVariants";

export interface ButtonProps
  extends ComponentProps<"button">, VariantProps<typeof buttonVariants> {
  icon?: LucideIcon;
  iconRight?: LucideIcon;
  /** Deshabilita y cambia el ícono por el spinner, sin mover el ancho. */
  loading?: boolean;
}

export function Button({
  variant,
  size,
  shape,
  icon: Icon,
  iconRight: IconRight,
  loading = false,
  disabled,
  className,
  children,
  type = "button",
  ...props
}: ButtonProps) {
  const iconClass = size === "2xs" || size === "xs" ? "size-3.5" : "size-4";
  return (
    <button
      type={type}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      className={cn(buttonVariants({ variant, size, shape }), className)}
      {...props}
    >
      {loading ? (
        <LoaderCircle
          aria-hidden
          strokeWidth={1.75}
          className={cn(iconClass, "animate-spin")}
        />
      ) : (
        Icon && <Icon aria-hidden strokeWidth={1.75} className={iconClass} />
      )}
      {children}
      {IconRight && <IconRight aria-hidden strokeWidth={1.75} className={iconClass} />}
    </button>
  );
}
